import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import WhySection from '@/components/landing/why-section'
import FeaturesSection from '@/components/landing/features-section'
import PhoneSignInSection from '@/components/landing/phone-sign-in-section'
import HowItWorksSection from '@/components/landing/how-it-works-section'
import FaqSection from '@/components/landing/faq-section'
import DemoSection from '@/components/landing/demo-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <WhySection />
            <FeaturesSection />
            <PhoneSignInSection />
            <HowItWorksSection />
            <FaqSection />
            <DemoSection />
        </Layout>
    )
}

export default Home
